import ClientLeadList from './ClientLeadList';

export default {
  ClientLeadList,
};
